import React from 'react';
import { MDBDataTableV5 } from 'mdbreact';
import 'mdbreact/dist/css/mdb.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './DataTableTickets.css';
import formatDateTime from '../../shared/utilities/formatDateTime';

class DataTableTickets extends React.Component {
    render(){
        const dataTickets = [...this.props.dataTickets].sort((a, b) => {
            return new Date(b.ticket.ultimaModificacion).getTime() - new Date(a.ticket.ultimaModificacion).getTime();
        });

        const datatable = {
            columns: [
                {
                    label: 'Id',
                    field: 'id',
                    width: 110,
                },
                {
                    label: 'Ult. Mod.',
                    field: 'ultimaModificacion',
                    width: 185,
                    sort: 'desc'
                },
                {
                    label: 'Instalacion',
                    field: 'instalacion',
                    width: 220,
                },
                {
                    label: 'Tipo',
                    field: 'tipo',
                    width: 180,
                },
                {
                    label: 'Usuario',
                    field: 'usuario',
                    width: 220,
                },
                {
                    label: 'Asunto',
                    field: 'asunto',
                    width: 400,
                },
                {
                    label: 'Urgente',
                    field: 'urgente',
                    width: 115,
                },
                {
                    label: 'Responsable',
                    field: 'responsable',
                    width: 200,
                },
                {
                    label: 'Mensajes',
                    field: 'mensajes',
                    width: 130,
                },
                {
                    label: 'Estado',
                    field: 'estado',
                    width: 120,
                },
            ],
            rows: dataTickets.map(ticketRes => {
                return {
                    id: ticketRes.ticket.caso,
                    ultimaModificacion: (
                        <span searchvalue={ticketRes.ticket.ultimaModificacion}>
                            {formatDateTime(ticketRes.ticket.ultimaModificacion)}
                        </span>
                    ),
                    instalacion: ticketRes.instalacionUsuario,
                    tipo: ticketRes.nombreTipo,
                    usuario: ticketRes.nombreUsuario,
                    asunto: ticketRes.ticket.asunto,
                    urgente: ticketRes.ticket.urgencia == 0 ? "No" : "Sí­",
                    responsable: ticketRes.nombreResponsable,
                    mensajes: ticketRes.numMensajes,
                    estado: ticketRes.ticket.estado,
                    ticketId: ticketRes.ticket.ticketId,

                    rowClassNames: (ticketRes.ticket.estado == "CERRADO" ? 'rows close' :
                                   ticketRes.ticket.estado == "PENDIENTE" ? 'rows pending' :
                                   ticketRes.ticket.estado == "PROCESO" ? 'rows process' :
                                   '') + (ticketRes.ticket.urgencia == 1 ? ' urgent' : ''),

                    clickEvent: (e) => this.props.navigate(`/soporte/ticket/${e.ticketId}`)
                }
            })
        };

        const filledDataTable = {
            columns: [
                ...datatable.columns.map((col) => {
                    return col;
                }),
            ],
            rows: [...datatable.rows],
        };

        return(
            <div className='dataTableTicketsWrapper'>
                <MDBDataTableV5
                    data = {filledDataTable}
                    style = {{ cursor: 'pointer'}}

                    sortRows={['ultimaModificacion']}
                    scrollX
                    fixed

                    paging = {true}
                    entriesOptions = {[12, 16, 24]}
                    entries = {16}
                    entriesLabel = {"Filas por página:"}
                    info = {true}
                    infoLabel = {["Mostrando", "-", "de", "entradas"]}
                    paginationLabel={['Anterior', 'Siguiente']}
                    fullPagination

                    sortable={true}

                    searching = {true}
                    searchTop = {true}
                    searchBottom = {false}
                    searchLabel = {"Buscar"}

                    noRecordsFoundLabel = {"No se han encontrado tickets"}
                />
            </div>
        )
    }
}

export default DataTableTickets;
